import { createElement, Component } from 'react';
import PropTypes from 'prop-types';
import { NOT_FOUND, ACCESS_DENIED } from '@App/api/errors';
import NotFound from '@App/components/page/error/NotFound';
import AccessDenied from '@App/components/page/error/AccessDenied';
import Internal from '@App/components/page/error/Internal';
import Loader from '@App/components/ui/Loader';

export default class MutationContent extends Component {
    static propTypes = {
        component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
        loading: PropTypes.bool.isRequired,
        data: PropTypes.object,
        error: PropTypes.object,
        mapResult: PropTypes.func,
        mapLoading: PropTypes.func,
        mapError: PropTypes.func,
        mutate: PropTypes.func,
        childProps: PropTypes.object,
        loadingComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
        errorComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    };

    static defaultProps = {
        data: null,
        error: null,
        mapResult: null,
        mapLoading: null,
        mapError: null,
        childProps: {},
        loadingComponent: Loader,
        errorComponent: null,
    };

    getErrorComponent(error, customErrorComponent = null) {
        if (customErrorComponent) {
            return customErrorComponent;
        }

        if (error.graphQLErrors.some(graphQLError => graphQLError.code === NOT_FOUND)) {
            return NotFound;
        }

        if (error.graphQLErrors.some(graphQLError => graphQLError.code === ACCESS_DENIED)) {
            return AccessDenied;
        }

        return Internal;
    }

    render() {
        const {
            loading,
            data,
            error,
            mapResult,
            mapLoading,
            mapError,
            component,
            loadingComponent,
            errorComponent,
            childProps,
            mutate,
        } = this.props;

        if (loading) {
            const loadingProps = typeof mapLoading === 'function' ? mapLoading() : { loading };

            return createElement(loadingComponent, { ...childProps, ...loadingProps, mutate });
        }

        if (error) {
            const errorProps = typeof mapError === 'function' ? mapError(error, data) : { error, data };

            return createElement(
                this.getErrorComponent(error, errorComponent),
                { ...childProps, ...errorProps, mutate }
            );
        }

        const resultProps = data === null ? {} : (typeof mapResult === 'function' ? mapResult(data) : { data });

        return createElement(component, { ...childProps, ...resultProps, mutate });
    }
}
